module.exports = __webpack_public_path__ + "img/instruction1.a8477d04.jpg";